import Api from '../../../shared/Api';
import { Promise } from 'es6-promise';

class ViewOrderApi {
    static get(id: number): Promise<any> {
        return new Api().get(`/views/orders/${id}`);
    }

    static getOrderIdByNumber(orderNumber: string): Promise<any> {
        return new Api()
            .get(`/views/orders/getId/${orderNumber.replace(':', '_')}`)
            .then((response: any) => {
                return response.orderId;
            });
    }

    static assignUser(id: number): Promise<any> {
        return new Api().post(`/views/orders/${id}/assignuser`, {});
    }

    static moveOrder(orderId: number, orderCollection: string): Promise<any> {
        return new Api().put(`/views/orders/${orderId}/move`, {
            orderCollection: orderCollection
        });
    }
}

export default ViewOrderApi;
